import React from "react"
import { SaveWrapper, SaveContainer, SaveText } from "../../UIKit/styles"

export default function SaveMessage({ message = ""}) {
  return (
    <SaveWrapper>
        <SaveContainer>
          <SaveText  data-testid="save-message-text">{message}</SaveText>
        <SaveText><a href="mailto:jayson.benge@zespri.com?subject=Orchard carbon footprint calculator">Contact us or send feedback</a></SaveText>
      <SaveText>This tool is indicative only and Zespri and its developers do not guarantee the accuracy, completeness or validity of the tool, or any results, outcomes or any decisions based on the use of the tool. Figures used by the tool may be averages or aggregated data which differs from the specific circumstances of your orchard. Any reliance on the tool is at your own risk.</SaveText>
      <SaveText>This web-based tool has been built for <a href="https://www.zespri.com" target="_blank"> Zespri</a> by <a href="https://www.gpsit.co.nz" target="_blank">GPS-IT</a>, from an excel version developed by <a href="https://agrilink.co.nz/" target="_blank">Agrilink</a> and <a href="https://www.agribusinessgroup.com/" target="_blank">The AgriBusiness Group</a>.</SaveText>
          
        </SaveContainer>
    </SaveWrapper>
  )
}
